import biboClient from './biboClient';
import _ from 'lodash';

const axiosInstance = biboClient.create();

export default {
    getList: () => {
        return axiosInstance.get('/admin/api/tableauMenuFolders')
    },
    create: (data) => {
        return axiosInstance.post('/admin/api/tableauMenuFolders', data)
    },
    edit: (id, data) => {
        data = _.pick(data, ['tableauMenuFolderId', 'title', 'parentId']);
        return axiosInstance.put(`/admin/api/tableauMenuFolders/${id}`, data)
    },
    delete: (id) => {
        return axiosInstance.delete(`/admin/api/tableauMenuFolders/${id}`)
    },

    getTableauConfigs: () => {
        return axiosInstance.get('/admin/api/tableauConfigs')
    },
    getTableauIdentitites: () => {
        return axiosInstance.get('/admin/api/tableauConfigs/TableauIdentities')
    },
    deleteTableauConfigs: (id) => {
        return axiosInstance.delete(`/admin/api/tableauConfigs/${id}`)
    },
    putTableauConfigs: (id, data) => {
        return axiosInstance.put(`/admin/api/tableauConfigs/${id}`, data)
    },
    postTableauConfigs: (data) => {
        return axiosInstance.post(`/admin/api/tableauConfigs`, data)
    },

    getTableauUsers: () => {
        return axiosInstance.get('/admin/api/TableauUsers/Users')
    },
    getTableauIdentities: () => {
        return axiosInstance.get('/admin/api/TableauUsers/TableauIdentities')
    },
    editPermission: (data) => {
        return axiosInstance.post('/admin/api/TableauUsers', data)
    },
}